import React, { useCallback } from 'react';
import style from './slidesAdmin.module.scss';
import { Button } from '@wordpress/components';
import { MediaUpload, MediaUploadCheck, RichText } from '@wordpress/block-editor';
import { useEditor } from '@smartfire/js-block-engine';
import type { SlideType } from '../slide';

type SlidesAdminProps = {
    slides: SlideType[];
};
export default function SlidesAdmin({ slides }: SlidesAdminProps) {
    const { updateData } = useEditor();
    const updateValue = useCallback(
        (key, value, i) => {
            slides[i][key] = value;
            updateData({ slides: [...slides] });
        },
        [slides, updateData],
    );

    const addSlide = useCallback(() => {
        let newSlide = {
            title: '',
            text: '',
            link: '',
            picture: null,
        };

        updateData({ slides: [...slides, newSlide] });
    }, [slides, updateData]);

    const deleteSlide = useCallback(
        (i) => {
            slides.splice(i, 1);
            updateData({ slides: [...slides] });
        },
        [slides, updateData],
    );
    return (
        <>
            {slides &&
                slides.map((item, i) => (
                    <div className={style.slideAdmin} key={`slide-admin-item-${i}`}>
                        <button className={style.deleteButton} onClick={() => deleteSlide(i)}>
                            <svg
                                aria-hidden="true"
                                role="img"
                                focusable="false"
                                className="dashicon dashicons-trash"
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                            >
                                <path d="M12 4h3c.6 0 1 .4 1 1v1H3V5c0-.6.5-1 1-1h3c.2-1.1 1.3-2 2.5-2s2.3.9 2.5 2zM8 4h3c-.2-.6-.9-1-1.5-1S8.2 3.4 8 4zM4 7h11l-.9 10.1c0 .5-.5.9-1 .9H5.9c-.5 0-.9-.4-1-.9L4 7z" />
                            </svg>
                        </button>
                        <RichText
                            tagName="h2"
                            placeholder={'ajouter un titre'}
                            formattingControls={[]}
                            value={item.title}
                            onChange={(value) => updateValue('title', value, i)}
                        />
                        <RichText
                            tagName="div"
                            placeholder={'ajouter un texte'}
                            formattingControls={[]}
                            value={item.text}
                            onChange={(value) => updateValue('text', value, i)}
                        />
                        <RichText
                            tagName="div"
                            placeholder={'lien "en savoir plus" (laisser vide pour ne pas afficher)'}
                            formattingControls={[]}
                            value={item.link}
                            onChange={(value) => updateValue('link', value, i)}
                        />
                        <div className={style.picture}>
                            <img src={item.picture?.url} alt={item.picture ? item.picture.alt : ''} />
                        </div>
                        <MediaUploadCheck>
                            <MediaUpload
                                allowedTypes={['image']}
                                value={item.picture ? item.picture.id : null}
                                render={({ open }) => (
                                    <Button className={style.backgroundImage} onClick={open}>
                                        Modifier l'image
                                    </Button>
                                )}
                                onSelect={(media) => updateValue('picture', media, i)}
                            />
                        </MediaUploadCheck>
                    </div>
                ))}
            <button className={style.addButton} onClick={() => addSlide()}>
                <svg
                    aria-hidden="true"
                    role="img"
                    focusable="false"
                    className="dashicon dashicons-insert"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                >
                    <path d="M10 1c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm1-11H9v3H6v2h3v3h2v-3h3V9h-3V6z" />
                </svg>
            </button>
        </>
    );
}
